module.exports = __webpack_public_path__ + "statics/img/12.65bc570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/12.png
// module id = K5ob
// module chunks = 1